import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { LIST_WIDTH, clampListWidth } from './storage'

/** The drag handle between the chats list and the chat (keyboard: ← →, 16 px a step). */
export function ListDivider({ width, onChange, onCommit }: { width: number; onChange: (px: number) => void; onCommit: (px: number) => void }) {
  const { t } = useTranslation('chats')
  const drag = useRef<{ id: number; x: number; w: number } | null>(null)
  const last = useRef(width)
  last.current = width
  return (
    <div
      className="cp-divider"
      role="separator"
      aria-orientation="vertical"
      aria-label={t('resizeList')}
      aria-valuemin={LIST_WIDTH.min}
      aria-valuemax={LIST_WIDTH.max}
      aria-valuenow={width}
      tabIndex={0}
      onKeyDown={(e) => {
        const step = e.key === 'ArrowRight' ? 16 : e.key === 'ArrowLeft' ? -16 : 0
        if (!step) return
        e.preventDefault()
        const next = clampListWidth(width + step)
        onChange(next)
        onCommit(next)
      }}
      onPointerDown={(e) => {
        drag.current = { id: e.pointerId, x: e.clientX, w: width }
        e.currentTarget.setPointerCapture?.(e.pointerId)
      }}
      onPointerMove={(e) => {
        const d = drag.current
        if (d && d.id === e.pointerId) onChange(clampListWidth(d.w + e.clientX - d.x))
      }}
      onPointerUp={(e) => {
        if (drag.current?.id !== e.pointerId) return
        drag.current = null
        onCommit(last.current)
      }}
    />
  )
}
